import { formatSobValue } from 'partner360/lib/metricFormatting'

const formatPercentValue = (value: number | null | undefined): string | null =>
  formatSobValue(value)

export const formatPercent = (value: number | null | undefined): string => {
  const formattedValue = formatPercentValue(value)
  return formattedValue === null ? '—' : `${formattedValue}%`
}

export const formatPercentChange = (value: number | null | undefined): string => {
  const formattedValue = formatPercentValue(value)
  if (formattedValue === null || value === null || value === undefined) {
    return '—'
  }

  return value >= 0 ? `+${formattedValue}%` : `${formattedValue}%`
}
